import stockService from 'stockService'
import utils from 'utils'
import modalReceiveInvoice from './views/modalReceiveInvoice.html'

class ReceiveBrachInvoiceListCtrl {
    constructor($rootScope, $scope, $uibModal, httpRequest, dateInterceptor, logger, receiveBranchInvoiceService, querySort, initSortService, sweetalert) {
    // $scope.toggle = true // 初始展开搜索框
        $scope.sale = $rootScope.userInfo.sale // 获取销方id
        $scope.isNotFindDisk = false
        $scope.selectedDevice = null
        const { saleCreditCode } = JSON.parse(localStorage.user_info).sale
        $scope.dictionary = { // 获取数据字典的数据
            stock_inv_type: [],
            stock_invType : [{enumCode:'0',enumName:'纸质专用发票'},{enumCode:'004',enumName:'纸质专用发票'}
                ,{enumCode:'2',enumName:'纸质普通发票'},{enumCode:'007',enumName:'纸质普通发票'}
                ,{enumCode:'12',enumName:'机动车发票'},{enumCode:'005',enumName:'机动车发票'}
                ,{enumCode:'41',enumName:'卷式发票'},{enumCode:'025',enumName:'卷式发票'}
                ,{enumCode:'51',enumName:'电子普通发票'},{enumCode:'026',enumName:'电子普通发票'}
                ,{enumCode:'52',enumName:'电子专用发票'},{enumCode:'028',enumName:'电子专用发票'}]
        }
        $scope.queryParam = { // 查询条件的参数
            pageNum: 1,
            pageSize: 100,
            param: {
                invoiceType: '',
                diskId: '',
                diskCode: '',
                disk: {},
                invoiceDateBegin: dateInterceptor.getDateStr(-3),
                invoiceDateEnd: dateInterceptor.getDateStr(0),
            },
        }
        $scope.reset = function () {
            $scope.queryParam.param.invoiceType = ''
            $scope.queryParam.param.invoiceDateBegin = dateInterceptor.getDateStr(-3)
            $scope.queryParam.param.invoiceDateEnd = dateInterceptor.getDateStr(0)
        }
        // 表头排序
        $scope.orderMap = initSortService()
        $scope.sortKeyArr = ['invoiceType', 'invoiceCount', '网络分配', 'invoiceTypeCode', 'invoiceNumberStart', 'devisionPerson', 'devisionDate']
        $scope.selectedHandle = function () {
            const sortKey = $scope.sortKeyArr[$scope.orderMap.sortKey]
            let list = []
            list = $scope.operateTable.invoiceListOrigin
            const result = utils.paging(list, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
            list = JSON.parse(JSON.stringify(result.resList))
            // list = JSON.parse(JSON.stringify(mock))
            if ($scope.orderMap.sortKey == 2) {
                $scope.operateTable.invoiceList = list
                return
            }
            if ($scope.orderMap.sortVal) {
                let type = 'string'
                if (sortKey == 'devisionDate') {
                    type = 'date'
                } else if (sortKey == 'invoiceCount' || sortKey == 'invoiceTypeCode' || sortKey == 'invoiceNumberStart') {
                    type = 'num'
                }
                const flag = $scope.orderMap.sortVal == 'desc' ? 1 : -1
                list.sort((a, b) => querySort.compareFun(a[sortKey], b[sortKey], type) * flag)
            }
            $scope.operateTable.invoiceList = list
        }
        // 监听开票起始日期
        $scope.$watch('queryParam.param.invoiceDateBegin', (newVal, oldVal) => {
            if (newVal > $scope.queryParam.param.invoiceDateEnd) $scope.queryParam.param.invoiceDateBegin = oldVal
        })
        // 监听开票结束日期
        $scope.$watch('queryParam.param.invoiceDateEnd', (newVal, oldVal) => {
            const today = dateInterceptor.getDateStr(0)
            if (newVal > today) $scope.queryParam.param.invoiceDateEnd = oldVal
        })
        $scope.operateForm = { // 操作列表
            title: '当前开票点',
            diskId: '',
            diskList: [],
        }
        $scope.operateForm.diskList = JSON.parse(localStorage.user_info).sysUkeyList
        if(null!=$scope.operateForm.diskList && $scope.operateForm.diskList.length>0){
            $scope.queryParam.param.diskCode = $scope.operateForm.diskList[0].diskNo
        }
        $scope.operateTable = { // 表格数据
            head: [
                '发票种类',
                '分票数量',
                '分票方式',
                '类别代码',
                '起始号码',
                //'分票人',
                //'分票/购票时间',
            ],
            invoiceListOrigin: [],
            invoiceList: [],
            total: 0, // 总记录数
        }
        // 获取待分配的发票(分盘)
        const queryAssignedInvoiceBranch = (diskCode, invoiceList = '') => {
            try {
                receiveBranchInvoiceService.queryAssignedInvoiceBranch(
                    $scope.queryParam.param.invoiceDateBegin.replace(/-/g, ''),
                    $scope.queryParam.param.invoiceDateEnd.replace(/-/g, ''),
                    diskCode,
                ).then((result) => {

                    $scope.operateTable.invoiceListOrigin = result
                    $scope.operateTable.total = result.length
                    invoiceList = utils.searchData($scope.operateTable.invoiceListOrigin, [{ type: 'invoiceType', value: $scope.queryParam.param.invoiceType }])
                    invoiceList ? $scope.paging(invoiceList) : $scope.paging()
                    $scope.$apply()
                }, (err) => {
                    logger.logError(err.data && err.data.message)
                })
            } catch (e) {
                $scope.operateTable.invoiceList = $scope.operateTable.invoiceListOrigin = []
            }
        }
       /* Promise.all([
            //httpRequest.get_getDiskBySaleId({ saleId: $scope.sale.saleId, type: '3' }), // 根据销方id查询金税盘
            httpRequest.get_dictByType(dicData), // 获取发票种类
        ]).then((res) => {
            //let diskList = res[0].data.value// 金税盘列表
            //const invoiceTypeList = res[1].data.value// 发票种类列表
            /!*diskList = diskList.filter((disk) => { // 过滤掉主盘
                disk.name = `${disk.diskCode}号分机  (${disk.diskName})`
                return Number(disk.diskCode) !== 0
            })*!/
            //$scope.operateForm.diskList = diskList
            //if(null!=diskList && diskList.length>0){
            //    $scope.queryParam.param.diskCode = diskList[0].diskCode
            //}
            //$scope.dictionary.stock_inv_type = invoiceTypeList
            // 初始化获取本地或者服务器金税盘
            //getTaxDisk()
        })*/
        // 获取当前本地金税盘或者服务器版金税盘
        const getTaxDisk = () => {
            $scope.isNotFindDisk = false
            try {
                receiveBranchInvoiceService.getDiskInfo($scope.operateForm.diskList).then((res) => {
                    $scope.standaloneFlag = 1
                    $scope.queryParam.param.diskCode = res.kpfwqh
                    $scope.queryParam.param.disk = res.disk
                    if (!IS_NO_KEY && saleCreditCode != res.TaxCode) {
                        logger.logError('金税盘的税号与用户所在企业税号不一致，请重新插入')
                        return
                    }
                    // // 初始化待发配的数据
                    queryAssignedInvoiceBranch(res.kpfwqh)
                }, (err) => {
                    if (!IS_NO_KEY) {
                        serverFn()
                    } else {
                        $scope.isNotFindDisk = true
                        logger.logError(err.data.message)
                    }
                })
            } catch (e) {
                if (!IS_NO_KEY) {
                    serverFn()
                } else {
                    $scope.isNotFindDisk = true
                }
            }
            function serverFn() {
                // try {
                httpRequest.get_qryServerDiskOfPlugged({ diskCode: '' }).then((res) => {
                    const serverData = res.data.value
                    let diskCode = '' // 分票机号
                    if (JSON.stringify(serverData) !== '{}' || !serverData) { // 服务器版金税盘返回value不为空对象或者null
                        if (serverData.length) {
                            let min = {}
                            serverData.forEach((data, index, arr) => {
                                arr[0] < data.diskCode ? (min = arr[0]) : (min = data)
                            })
                            diskCode = min.diskCode
                        } else diskCode = serverData.diskCode
                        $scope.queryParam.param.diskCode = diskCode
                        $scope.queryParam.param.disk = $scope.operateForm.diskList.filter((disk) => disk.diskCode === diskCode)
                        $scope.queryParam.param.disk = $scope.queryParam.param.disk[0]
                        // 初始化待发配的数据
                        queryAssignedInvoiceBranch(serverData.diskCode)
                    } else $scope.isNotFindDisk = true// 提示未找到金税盘
                }, () => {
                    $scope.isNotFindDisk = true// 提示未找到金税盘
                })
            }
            $scope.$apply()
        }

        function getLocalTime(nS) {
            if(null==nS || nS.length<8){
                return ""
            }
            return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ')
        }
        // 点击搜索执行的方法
        $scope.queryList = () => {
            if (dateInterceptor.getDays($scope.queryParam.param.invoiceDateBegin, $scope.queryParam.param.invoiceDateEnd) > 90) {
                logger.logError('开票日期相差天数不能大于90天')
                return
            }
            //查询可下载票源
            if(null==$scope.queryParam.param.diskCode || $scope.queryParam.param.diskCode==''){
                logger.logError('请先选择一个开票点')
                return
            }

            $scope.operateForm.diskList.forEach((item)=>{
                if(item.diskNo===$scope.queryParam.param.diskCode){
                    $scope.selectedDevice = item
                }
            })
            utils.loading("数据加载中")
            if($scope.selectedDevice.manageType==='3'){
                var requestData = {
                    taxNo: $scope.sale.saleCreditCode,
                    machineCode: $scope.selectedDevice.diskNo
                }
                httpRequest.post_queryInvoiceSource(requestData).then((res)=>{
                    if(res.data.value.businessData.invoiceDetails){
                        $scope.operateTable.invoiceList = []
                        res.data.value.businessData.invoiceDetails.forEach((item)=>{
                            const inv = {
                                invoiceType: item.invoiceCategory,
                                invoiceCount: item.numberOfInvoices,
                                invoiceTypeCode: item.categoryCode,
                                invoiceNumberStart: item.startNum,
                                operateDevice: $scope.selectedDevice
                            }
                            $scope.operateTable.invoiceList.push(inv)

                        })
                        $scope.operateTable.total = $scope.operateTable.invoiceList.length
                    }
                    utils.loaded()
                },(error)=>{
                    console.log(error)
                    utils.loaded()
                })
            }else if($scope.selectedDevice.manageType==='4'){
                $scope.isNotFindDisk = false
                //调用后台查询申领记录
                utils.loading('数据加载中')
                const requestData = {
                    dealDateStart: $scope.queryParam.param.invoiceDateBegin,
                    dealDateEnd: $scope.queryParam.param.invoiceDateEnd,
                    operateStatus: $scope.queryParam.param.status
                }
                httpRequest.post_queryOvatOnlineApplyRecordDetail(requestData).then((res) =>{
                    utils.loaded()
                    $scope.operateTable.invoiceList = []
                    if(res.data.value && res.data.value.list){
                        res.data.value.list.forEach((item)=>{
                            if( item.invoiceVolumeList && item.invoiceVolumeList.length>0){
                                item.invoiceVolumeList.forEach((ii)=>{
                                    const _item = {
                                        invoiceType: ii.invoiceType,
                                        invoiceCount: ii.invoiceCount,
                                        invoiceTypeCode: ii.invoiceCode,
                                        invoiceNumberStart: ii.invoiceNumberStart,

                                        taskNum: ii.taskNum,
                                    }
                                    $scope.operateTable.invoiceList.push(_item)
                                })
                            }
                        })
                        $scope.operateTable.total = $scope.operateTable.invoiceList.length
                    }
                    utils.loaded()
                },(error)=>{
                    utils.loaded()
                    logger.logError(error)
                })
            }
            /*$scope.queryParam.pageNum = 1 // 每次点击搜索回到第一页
            // queryAssignedInvoiceBranch()
            $scope.operateTable.invoiceList = utils.searchData($scope.operateTable.invoiceListOrigin, [{ type: 'invoiceType', value: $scope.queryParam.param.invoiceType }, { type: 'devisionDate', value1: $scope.queryParam.param.invoiceDateBegin.replace(/-/g, ''), value2: $scope.queryParam.param.invoiceDateEnd.replace(/-/g, '') }])
            $scope.operateTable.invoiceList ? $scope.paging($scope.operateTable.invoiceList) : $scope.paging()
            try {
                $scope.selectedHandle()
            } catch (e) {

            }*/

        }
        // 选择页码执行的方法
        $scope.paging = (invoiceList) => {
            let list = []
            invoiceList ? (list = invoiceList) : (list = $scope.operateTable.invoiceListOrigin)
            const result = utils.paging(list, $scope.queryParam.pageSize, $scope.queryParam.pageNum)
            $scope.operateTable.invoiceList = result.resList
            $scope.operateTable.total = list.length
            try {
                $scope.selectedHandle()
            } catch (e) {

            }
            $scope.$apply()
        }
        // 选择金税盘执行的方法
        $scope.taxDiskChange = async () => {
            $scope.queryParam.param.disk = $scope.operateForm.diskList.filter((op) => op.diskCode === $scope.queryParam.param.diskCode)
            $scope.queryParam.param.disk = $scope.queryParam.param.disk[0]
            const { diskType } = $scope.queryParam.param.disk
            $scope.isNotFindDisk = false
            if (Number(diskType) === 2) {
                try {
                    let res = await stockService.getDiskInfo() // 获取本地金税盘信息
                    res = JSON.parse(res)
                    if (saleCreditCode != res.TaxCode) {
                        logger.logError('金税盘的税号与用户所在企业税号不一致，请重新插入')
                        return
                    }
                    $scope.standaloneFlag = 1
                    if ($scope.queryParam.param.diskCode != res.kpfwqh) {
                        logger.logError(`未检测到${$scope.queryParam.param.diskCode}号分票机，请插入后，重新刷新本页面`)
                    }
                } catch (err) {
                    $scope.operateTable.invoiceList = []
                }
            } else if (Number(diskType) === 1) {
                receiveBranchInvoiceService.qryServerDiskOfPlugged($scope.queryParam.param.diskCode).then(() => {
                    queryAssignedInvoiceBranch($scope.queryParam.param.disk.diskCode)
                },
                (diskCodeParam) => {
                    $scope.operateTable.invoiceList = []
                    logger.logError(`未检测到${diskCodeParam}号服务器，请检测网络和分盘服务器后刷新本页面`)
                })
            }
        }
        // 弹出读入发票模态框
        $scope.readInvoice = (invoice) => {
            if($scope.selectedDevice.manageType==='4'){
                let uKeyList = $scope.operateForm.diskList.filter((disk) => disk.diskNo === $scope.queryParam.param.diskCode)
                const getData =  {
                    extensionNumber:uKeyList[0].diskCode,                // 分机号
                    equipNumber: $scope.selectedDevice.diskNo,                // 机器编号
                    taxNum:$scope.sale.saleCreditCode,                // 税号
                }
                httpRequest.get_downloadInvoiceApply(getData).then((res)=>{
                    if(res.data.success){
                        logger.logSuccess('发票读入成功!')
                    }
                },(error)=>{
                    logger.logError(error)
                    utils.loaded()
                })

            }else {
                const params = invoice
                const modalInstance = $uibModal.open({
                    template: modalReceiveInvoice,
                    controller: 'modalReceiveInvoiceCtrl',
                    openedClass: 'mod-modal-readinvoice mod-modal mod-modal-lg',
                    backdrop: 'static',
                    resolve: {
                        items1() {
                            return params
                        },
                    },
                })
                modalInstance.result.then((data) => {
                    try {
                        var requestData = null;
                        if($scope.selectedDevice && $scope.selectedDevice.diskType==2){
                            //金税盘只设置发票数量
                            requestData = {
                                taxNo: $scope.sale.saleCreditCode,
                                invoiceCategory: data.invoiceType,
                                categoryCode: '',
                                startNum: '',
                                invoiceQuantity: data.sureCount,
                                machineCode: $scope.selectedDevice.diskNo
                            }
                        }else{
                            requestData = {
                                taxNo: $scope.sale.saleCreditCode,
                                invoiceCategory: data.invoiceType,
                                categoryCode: data.invoiceTypeCode,
                                startNum: data.invoiceNumberStart,
                                invoiceQuantity: data.sureCount,
                                machineCode: $scope.selectedDevice.diskNo
                            }
                        }
                        utils.loading('发票读入中')
                        $scope.operateTable.invoiceList = []
                        httpRequest.post_invoiceSourceDown(requestData).then((res)=>{
                            console.log(res)
                            logger.logSuccess('发票读入成功!')
                            utils.loaded()
                            //$scope.queryList()
                        },(error)=>{
                            console.log(error)
                            utils.loaded()
                        })
                        /*receiveBranchInvoiceService.downloadInvoiceBranch(data, $scope.queryParam.param.disk).then((message) => {
                            queryAssignedInvoiceBranch($scope.queryParam.param.disk.diskCode)
                            message ? logger.logError(message) : logger.logSuccess('发票读入成功!')
                        }, () => {
                            logger.logError('发票读入失败, 请稍后再试!')
                        })*/
                    } catch (e) {
                        logger.logError('发票读入失败, 请稍后再试!')
                    }
                }).catch((err) => console.log(err))
            }

        }
    }
}

ReceiveBrachInvoiceListCtrl.$inject = ['$rootScope', '$scope', '$uibModal', 'httpRequest', 'dateInterceptor', 'logger', 'receiveBranchInvoiceService', 'querySort', 'initSortService', 'sweetalert']

export default ReceiveBrachInvoiceListCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/receiveBranchInvoice/receiveBranchInvoiceListCtrl.js